<template>
  <div class="container-fluid" style="width:1115px !important">
    <div class="d-block" style="color:black !important; margin-top:-900px !important">
      <div class="pt-5 mb-1 pb-2 border-bottom" style="color:black !important">
          <div class="row">
              <div class="col">
                  <div class="d-flex align-items-center mb-3 flex-1">
                      <div class="d-block me-3">
                          <div class="avatar">
                              <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                          </div>
                      </div>
                      <div class="d-block overflow-hidden">
                          <div class="d-block h1 m-0 display-tektur block-ellipsis">{{ dataUsers.fullname }}</div>
                          <div class="d-block">{{ dataUsers.name }}</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="row justify-content-center mt-5">
        <div class="col-md-12">
          <div class="d-block h2 font-bold">
            <div class="row">
              <div class="col">
                <i class="fa-solid fa-caret-right me-3 text-neon"></i> Resume Peluang Pilihan dan Pilihan Alternatif
              </div>
            </div>
          </div>

          <div class="d-block" style="color:black !important; background-color:transparent !important;">
            <div class="card" style="color:black !important; background-color:transparent !important">
              <div class="card-body">
                <div class="d-block h3 m-0">Sesuai Pilihan Kamu</div>
              </div>
              <table class="table table-sm-th table-sm-td table-sm mb-1">
                <thead>
                  <tr>
                    <th class="ps-4" style="color:black !important; background-color:transparent !important">Jurusan</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Rerata Rapor</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Prasyarat</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Rerata Rapor Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Prasyarat Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Nilai</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Pendukung</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dataEvaluation" :key="index">
                    <td class="ps-4 font-bold m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.university_name }} - {{ item.major_fullname }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_subject }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_prerequisite }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_score }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_support }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.opportunity }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="html2pdf__page-break"/>          
                    
          <div class="d-block" style="color:black !important; background-color:transparent !important">
            <div class="card" style="color:black !important; background-color:transparent !important">
              <div class="card-body">
                <div class="d-block h3 m-0">Alternatif Pilihan Sesuai Minat Jurusan Pertama</div>
              </div>
              <table class="table table-sm-th table-sm-td table-sm mb-1">
                <thead>
                  <tr>
                    <th class="ps-4" style="color:black !important; background-color:transparent !important">Jurusan</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Rerata Rapor</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Prasyarat</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Rerata Rapor Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Prasyarat Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Nilai</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Pendukung</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dataAltMajor.alt_one" :key="index">
                    <td class="ps-4 font-bold m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.university_name }} - {{ item.major_fullname }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_subject }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_prerequisite }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_score }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_support }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.opportunity }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="html2pdf__page-break"/>          
          
          <div class="d-block" style="color:black !important; background-color:transparent !important">
            <div class="card" style="color:black !important; background-color:transparent !important">
              <div class="card-body">
                <div class="d-block h3 m-0">Alternatif Pilihan Sesuai Minat Jurusan Kedua</div>
              </div>
              <table class="table table-sm-th table-sm-td table-sm mb-1">
                <thead>
                  <tr>
                    <th class="ps-4" style="color:black !important; background-color:transparent !important">Jurusan</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Rerata Rapor</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Prasyarat</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Rerata Rapor Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Prasyarat Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Nilai</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Pendukung</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dataAltMajor.alt_two" :key="index">
                    <td class="ps-4 font-bold m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.university_name }} - {{ item.major_fullname }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_subject }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_prerequisite }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_score }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_support }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.opportunity }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="html2pdf__page-break"/>
          
          <div class="d-block" style="color:black !important; background-color:transparent !important">
            <div class="card" style="color:black !important; background-color:transparent !important">
              <div class="card-body">
                <div class="d-block h3 m-0">Alternatif Pilihan Sesuai Minat Rumpun Pertama</div>
              </div>
              <table class="table table-sm-th table-sm-td table-sm mb-1">
                <thead>
                  <tr>
                    <th class="ps-4" style="color:black !important; background-color:transparent !important">Jurusan</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Rerata Rapor</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Prasyarat</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Rerata Rapor Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Prasyarat Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Nilai</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Pendukung</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dataAltGroupSubject.alt_one" :key="index">
                    <td class="ps-4 font-bold m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.university_name }} - {{ item.major_fullname }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_subject }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_prerequisite }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_score }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_support }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.opportunity }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>          

          <div class="html2pdf__page-break"/>

          <div class="d-block" style="color:black !important; background-color:transparent !important">
            <div class="card" style="color:black !important; background-color:transparent !important">
              <div class="card-body">
                <div class="d-block h3 m-0">Alternatif Pilihan Sesuai Minat Rumpun Kedua</div>
              </div>
              <table class="table table-sm-th table-sm-td table-sm mb-1">
                <thead>
                  <tr>
                    <th class="ps-4" style="color:black !important; background-color:transparent !important">Jurusan</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Rerata Rapor</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Min Nilai Prasyarat</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Rerata Rapor Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Nilai Prasyarat Saya</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Nilai</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Pendukung</th>
                    <th class="text-center" style="color:black !important; background-color:transparent !important">Index Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dataAltGroupSubject.alt_two" :key="index">
                    <td class="ps-4 font-bold m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.university_name }} - {{ item.major_fullname }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.passing_grade }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_subject }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.avg_score_prerequisite }}
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_score }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.index_support }}%
                    </td>
                    <td class="text-center display-tektur h2 m-0" style="color:black !important; background-color:transparent !important">
                      {{ item.opportunity }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EvaluationPrint',
    props: {
    dataUsers: {
      type: Array,
      default: () => []
    },
    dataEvaluation: {
      type: Array,
      default: () => []
    },
    dataAltMajor: {
      type: Array,
      default: () => []
    },
    dataAltGroupSubject: {
      type: Array,
      default: () => []
    },
    }    
  }
</script>